import { createReducer } from '@reduxjs/toolkit'
import cloneDeep from 'lodash/cloneDeep'

import { DATES, AGGREGATION } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'

import {
    defaultResourcePageTabs,
    defaultResourcePageWidgets,
    defaultResourcePage,
} from '../defaults'

const defaultState = {
    [LOCAL_FILTERS]: {},
    [FILTER_SETTINGS]: {
        anchored: [DATES, AGGREGATION],
        order: [],
        displayState: {},
    },

    ...defaultResourcePage,

    tabs: defaultResourcePageTabs,
    widgets: defaultResourcePageWidgets('productPage'),
}

export default createReducer(cloneDeep(defaultState), () => {}) // create clone, so the defaultState is not mutated
